module.exports = __webpack_public_path__ + "media/images/icon__checkmark-353d74a8541d14e02fd2e80b2bddc002.png";